import { ReactNode } from "react";

import { OrgRoleType, SectionRoleType } from "components/server-types";
import { t } from "i18n/i18n";
import { Tooltip } from "mds/components/Tooltip";
import {
  PersonCourseAdminIcon,
  PersonSingleIcon,
  PersonSingleStarIcon,
  StarFilledIcon,
  StarIcon,
} from "mds/icons";
import { getSectionResourceRole } from "utils/section";

export type ExtendedOrgRoleType = OrgRoleType | "superuser" | "course_admin";

// TODO: Combine with home roles
// eslint-disable-next-line react-refresh/only-export-components
export const ORG_ROLE_TO_ICON: Record<ExtendedOrgRoleType, ReactNode> = {
  superuser: <StarFilledIcon />,
  admin: <StarIcon />,
  course_admin: <PersonCourseAdminIcon />,
  other: <PersonSingleIcon />,
  recording_agent: null,
  none: null,
};

// eslint-disable-next-line react-refresh/only-export-components
export const SECTION_ROLE_TO_ICON: Record<SectionRoleType, ReactNode> = {
  instructor: <StarIcon />,
  section_assistant: <PersonSingleStarIcon />,
  student: <PersonSingleIcon />,
  recording_agent: null,
};

export const SectionRoleIconWithTooltip = ({
  role,
  extraContent = null,
}: {
  role: SectionRoleType;
  extraContent?: ReactNode;
}) => {
  const resourceRole = getSectionResourceRole(role);

  const content = (
    <>
      {t(`roles.section_${resourceRole}_explanation`)}
      {extraContent}
    </>
  );
  return <Tooltip text={content}>{SECTION_ROLE_TO_ICON[role]}</Tooltip>;
};

export const OrgRoleIconWithTooltip = ({
  role,
  extraContent = null,
}: {
  role: ExtendedOrgRoleType;
  extraContent?: ReactNode;
}) => {
  const content = (
    <>
      {t(`roles.org_${role}_explanation`)}
      {extraContent}
    </>
  );
  return <Tooltip text={content}>{ORG_ROLE_TO_ICON[role]}</Tooltip>;
};
